import { useState } from "react";
import { CrearEntidadForm, Input, Textarea } from "@/components/ui";
import { toastError } from "@/lib/toast";
import { useCrearRol } from "../hooks/use-roles-mutations";

const NOMBRE_RE = /^[A-Za-z0-9_]+$/;

/**
 * Formulario de creación de un rol personalizado · nombre (sin espacios, para
 * usarlo como identificador de rol de Identity) + descripción opcional.
 */
export function RolCrearForm({ onSalir }: { onSalir: () => void }) {
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const crear = useCrearRol({ onCreado: onSalir });

  const submit = () => {
    const n = nombre.trim();
    if (!n) {
      toastError({ title: "Datos incompletos", message: "El nombre del rol es obligatorio." });
      return;
    }
    if (!NOMBRE_RE.test(n)) {
      toastError({ title: "Nombre inválido", message: "Solo letras, dígitos y guion bajo (sin espacios)." });
      return;
    }
    crear.mutate({ nombre: n, descripcion: descripcion.trim() || null });
  };

  return (
    <CrearEntidadForm
      titulo="Nuevo rol personalizado"
      descripcion="El nombre no admite espacios (es el identificador del rol). La descripción es opcional. Un rol personalizado es una etiqueta asignable a usuarios; no otorga permisos hasta cablearse en el código."
      cols={2}
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Input
        label="Nombre"
        placeholder="Ej. ConsultorExterno"
        value={nombre}
        onChange={(e) => setNombre(e.currentTarget.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") submit();
        }}
        maxLength={60}
        required
      />
      <Textarea
        label="Descripción (opcional)"
        placeholder="¿Para qué sirve este rol?"
        value={descripcion}
        onChange={(e) => setDescripcion(e.currentTarget.value)}
        maxLength={300}
        rows={2}
      />
    </CrearEntidadForm>
  );
}
